import { loadImage } from "./app/utils";


const fetchImage = async (baseName: string) => {

        let path = await loadImage(`patienticon${baseName}.png`, `patienticon.png`);
        //path = await loadImage(`patienticon.png`)                
        return path
    };

export const updateManifest = async (baseName: string, condition: string) => {
  const patientPinPNG = await fetchImage (baseName) 
  const manifest = {
    name: `${condition} Patient Connect`,//location.pathname === "/dashboard" ? "Dashboard App" : "My React App",
    short_name: "PatientConnect`",
    start_url: window.location.href,//location.pathname,
    display: "standalone",
    //theme_color: location.pathname === "/dashboard" ? "#000000" : "#ffffff",
    background_color: "#ffffff",
    ...patientPinPNG ? {
      icons: [
        {
          src: patientPinPNG as string,//location.pathname === "/dashboard" ? "/icon-dark.png" : "/icon-light.png",
          type: "image/png",
          sizes: "192x192"
        }
      ]
    } : {}
  };

  const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);

  let link = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }
  link.href = manifestURL;
  return patientPinPNG
};

export const addiOSNetaTags = (patientPinPNG: string, condition: string) => {
  if (patientPinPNG) {
    // Set apple-touch-icon
    let touchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (!touchIcon) {
      touchIcon = document.createElement("link");
      touchIcon.setAttribute("rel", "apple-touch-icon");
      document.head.appendChild(touchIcon);
    }
    touchIcon.setAttribute("href", patientPinPNG);

    // Set app name
    let appTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!appTitle) {
      appTitle = document.createElement("meta");
      appTitle.setAttribute("name", "apple-mobile-web-app-title");
      document.head.appendChild(appTitle);
    }
    appTitle.setAttribute("content", `${condition} Patient Connect`);

    // Set capable flag
    let capable = document.querySelector('meta[name="apple-mobile-web-app-capable"]');
    if (!capable) {
      capable = document.createElement("meta");
      capable.setAttribute("name", "apple-mobile-web-app-capable");
      document.head.appendChild(capable);
    }
    capable.setAttribute("content", "yes");
  }
}

 // Update page metadata
 export function updateMetadata(condition: string) {
  document.title = `${condition} Patient Connect`;
  
  const metaTag = document.querySelector('meta[name="application-name"]');
  if (metaTag) {
    metaTag.setAttribute("content", `${condition} Patient Connect`);
  }
  
  const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleTitle) {
    appleTitle.setAttribute("content", `${condition} Patient Connect`);
  }
}

export const initializeAppMetadata: ( baseName: string, condition: string) => void = async  (baseName, condition) => {
  updateMetadata(condition)
  const patientPinPNG = await updateManifest(baseName, condition)
  addiOSNetaTags(patientPinPNG as string, condition)
}
//function initializeAppMetadata(condition: string) {
      // Function to load and test an image URL
      // async function loadImage(primarySrc, fallbackSrc) {
      //   return new Promise((resolve) => {
      //     const img = new Image();
      //     img.onload = () => resolve(primarySrc);
      //     img.onerror = () => {
      //       if (fallbackSrc) {
      //         const fallbackImg = new Image();
      //         fallbackImg.onload = () => resolve(fallbackSrc);
      //         fallbackImg.onerror = () => resolve(null);
      //         fallbackImg.src = fallbackSrc;
      //       } else {
      //         resolve(null);
      //       }
      //     };
      //     img.src = primarySrc;
      //   });
      // }
      
      // // Load patient icon image
      // async function loadPatientIcon() {
      //   // Use the baseName from condition
      //   const baseName = condition.toLowerCase().replace(/\s+/g, '-');
        
      //   // Try loading condition-specific icon first, fallback to default
      //   const iconPath = await loadImage(
      //     `patienticon${baseName}.png`, 
      //     `patienticon.png`
      //   );
        
      //   // Update favicon and apple touch icon if we found a valid image
      //   if (iconPath) {
      //     const faviconLink = document.getElementById('favicon-link');
      //     if (faviconLink) faviconLink.href = iconPath;
          
      //     const appleIcon = document.getElementById('apple-touch-icon');
      //     if (appleIcon) appleIcon.href = iconPath;
          
      //     // Store the path for later use
      //     window.patientPinPNG = iconPath;
      //     document.documentElement.dataset.patientIcon = iconPath;
      //   }
        
      //   return iconPath;
      // }
      
     
      
    //   // Create and update manifest
    //   async function updateManifest(iconPath: string) {
    //     const manifest = {
    //       name: `${condition} Patient Connect`,
    //       short_name: "PatientConnect",
    //       start_url: window.location.href,
    //       display: "standalone",
    //       background_color: "#ffffff",
    //       icons: [
    //         {
    //           src: iconPath || "/patienticon.png",
    //           type: "image/png",
    //           sizes: "192x192"
    //         }
    //       ]
    //     };
        
    //     const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
    //     const manifestURL = URL.createObjectURL(blob);
        
    //     const manifestLink = document.getElementById('manifest-link');
    //     if (manifestLink) {
    //       manifestLink.href = manifestURL;
    //     }
    //   }
      
    //   // Main initialization sequence
    //   async function initialize() {
    //     // Update basic metadata immediately
    //     updateMetadata();
        
    //     // Load the patient icon
    //     const iconPath = await loadPatientIcon();
        
    //     // Update the manifest with the icon path
    //     await updateManifest(iconPath);
    //   }
      
    //   // Return the initialize function for execution
    //   return initialize;
    // }
    
    // You would call this function when the condition is available
    // Example: When DOM is loaded
    // window.addEventListener('DOMContentLoaded', () => {
    //   // This could be set from server-side or derived from the URL
    //   const condition = "Bladder Cancer"; // Replace with your actual condition source
      
    //   // Initialize the app metadata
    //   const initialize = initializeAppMetadata(condition);
    //   initialize();
    // });
  